import {
  CheckMetadata,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import { BusinessWebsiteDomainResolvableDetection } from 'dashboard/models/check';

export const computeBusinessWebsiteDomainResolvableDetectionMetadata = (
  check: BusinessWebsiteDomainResolvableDetection,
): CheckMetadata => {
  const ipAddresses = check.metadata?.['ip-addresses'];

  return {
    metadata: createSimpleCheckMetadataArray([
      {
        label: 'Resolved IP Addresses',
        value: ipAddresses ? ipAddresses.join(', ') : '-',
      },
    ]),
    hideIfVerificationPassed: false,
  };
};
